import { ReactNode } from 'react';
import {
  AppBar,
  Paper,
  Stack,
  Toolbar,
  toolbarClasses,
} from '@rossum/ui/material';

type DocumentTopBarProps = {
  start?: ReactNode;
  center?: ReactNode;
  end?: ReactNode;
};

export const DocumentTopBar = ({ start, center, end }: DocumentTopBarProps) => (
  <AppBar
    position="static"
    sx={{
      zIndex: 100,
      boxShadow: 'none',
      border: 'none',
    }}
  >
    <Toolbar
      variant="dense"
      component={Paper}
      elevation={0}
      square
      sx={{
        borderBottom: theme => `1px ${theme.palette.divider} solid`,
        boxShadow: 'none',
        [`&.${toolbarClasses.root}`]: {
          px: 1,
          py: 0,
        },
      }}
    >
      <Stack
        direction="row"
        sx={{
          width: '100%',
          whiteSpace: 'nowrap',
        }}
      >
        <Stack
          direction="row"
          spacing={0}
          data-cy="document-topbar-start"
          sx={{
            boxSizing: 'border-box',
            pr: 2,
            flex: '1 1 0',
            minWidth: 0,
            overflow: 'hidden',
            alignItems: 'center',
          }}
        >
          {start}
        </Stack>
        <Stack
          direction="row"
          spacing={1}
          data-cy="document-topbar-center"
          sx={{
            boxSizing: 'border-box',
            px: 2,
            flex: '0 0 auto',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {center}
        </Stack>
        <Stack
          direction="row"
          spacing={1}
          data-cy="document-topbar-end"
          sx={{
            boxSizing: 'border-box',
            pl: 2,
            flex: '1 1 0',
            minWidth: 0,
            overflow: 'hidden',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          {end}
        </Stack>
      </Stack>
    </Toolbar>
  </AppBar>
);
